import React from "react";
import DynamicTable from "./DynamicTableEdit";
import Navbar from "../components/Navbar";
import { toast, ToastContainer } from "react-toastify";
import RichTextComponent from "../components/RichTextComponent";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const EditForm = (props) => {
  const { report, table, data, form, opened } = props;

  const initialValues = data.reduce((acc, item) => {
    const [key, value] = Object.entries(item)[0];
    acc[key] = value;
    return acc;
  }, {});

  const handleSubmit = (formData) => {
    const transformedData = Object.keys(formData).map((key) => ({
      [key]: formData[key],
    }));

    const dataToSend = {
      report_id: report.id,
      data: transformedData,
    };

    fetch(`/reports/${report.id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataToSend),
    })
      .then(async (response) => {
        if (response.ok) {
          toast.success("Форма успешно обновлена!");
        } else {
          const errorData = await response.json();
          toast.error(
            `Ошибка при обновлении формы: ${
              errorData.error || "Неизвестная ошибка"
            }`
          );
        }
      })
      .catch((error) => {
        console.error("Ошибка сети:", error);
        toast.error("Ошибка сети. Попробуйте снова.");
      });
  };
  const exportToPDF = async () => {
    const content = document.getElementById("pdf-content");
  
    // Создаем клон содержимого
    const clone = content.cloneNode(true);
  
    // Заменяем все инпуты на p-теги в клоне
    const inputs = clone.querySelectorAll("input");
    inputs.forEach((input) => {
      const p = document.createElement("p");
      p.textContent = input.value;
      input.parentNode.replaceChild(p, input);
    });
  
    // Временно добавляем клон в документ для корректного рендера
    const offScreenDiv = document.createElement("div");
    offScreenDiv.style.position = "fixed";
    offScreenDiv.style.top = "-9999px";
    offScreenDiv.style.left = "-9999px";
    offScreenDiv.appendChild(clone);
    document.body.appendChild(offScreenDiv);
  
    // Используем html2canvas для рендеринга содержимого в канвас
    const canvas = await html2canvas(clone, {
      scale: 2, // Увеличиваем качество
      ignoreElements: (element) => element.classList.contains("no-print"),
    });
  
    // Удаляем временный контейнер
    document.body.removeChild(offScreenDiv);
  
    const pdf = new jsPDF("p", "mm", "a4");
  
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
  
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
  
    const imgData = canvas.toDataURL("image/png");
  
    const scaleFactor = pdfWidth / canvasWidth;
    const scaledHeight = canvasHeight * scaleFactor;
  
    let yPosition = 0;
  
    // Разбиваем содержимое на страницы
    while (yPosition < scaledHeight) {
      const nextHeight = Math.min(scaledHeight - yPosition, pdfHeight);
  
      // Вырезаем часть изображения
      const croppedCanvas = document.createElement("canvas");
      croppedCanvas.width = canvas.width;
      croppedCanvas.height = Math.floor(nextHeight / scaleFactor);
  
      const ctx = croppedCanvas.getContext("2d");
      ctx.drawImage(
        canvas,
        0,
        yPosition / scaleFactor,
        canvas.width,
        croppedCanvas.height,
        0,
        0,
        canvas.width,
        croppedCanvas.height
      );
  
      const croppedImgData = croppedCanvas.toDataURL("image/png");
  
      // Добавляем изображение в PDF
      pdf.addImage(
        croppedImgData,
        "PNG",
        0,
        0,
        pdfWidth,
        (croppedCanvas.height * pdfWidth) / croppedCanvas.width
      );
  
      yPosition += nextHeight;
  
      if (yPosition < scaledHeight) {
        pdf.addPage();
      }
    }
  
    pdf.save("report.pdf");
  };
  
  
  
  
  return (
    <div className="min-h-full">
      <ToastContainer />
      <div className="pb-32">
        <Navbar props={props} />
      </div>

      {/* Основной контент */}
      <main className="-mt-32">
        <div className="mx-auto container max-w-screen-2xl px-4 pb-12" id="pdf-content">
          <header className="flex mt-20 flex-col md:flex-row justify-between items-center border-b border-gray-300 pb-4 mb-5">
            <div className="text-left md:ml-4">
              <button
                onClick={exportToPDF}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700 no-print"
              >
                Экспорт в PDF
              </button>
            </div>
            <div className="text-right md:mr-4 mt-4 md:mt-0">
              <RichTextComponent richText={form.header} />
            </div>
          </header>
          <main className="mb-5">
            <h1 className="text-center text-lg md:text-xl font-bold mb-6">
              {form.form_name}
            </h1>
            <div className="text-sm md:text-base space-y-2">
              <RichTextComponent richText={form.information} />
            </div>
          </main>
          <DynamicTable
            sections={table}
            onSubmit={handleSubmit}
            initialValues={initialValues}
          />

        </div>
      </main>
    </div>
  );
};

export default EditForm;
